import { render, staticRenderFns } from "./OsMakeReturn.vue?vue&type=template&id=75cddca8"
import script from "./OsMakeReturn.vue?vue&type=script&lang=js"
export * from "./OsMakeReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports